export const RESPONSIVE_SIZE_SP = 768;
export const RESPONSIVE_SIZE_COLUMN_1 = 375;
export const RESPONSIVE_SIZE_COLUMN_2 = 756;
export const RESPONSIVE_SIZE_COLUMN_3 = 1137;
export const RESPONSIVE_SIZE_COLUMN_4 = 1518;
export const RESPONSIVE_SIZE_COLUMN_5 = 1899;

export const TEXT_PRIMARY = '#25292e';
export const TEXT_SECONDARY = '#596068';
export const ORANGE_RED = '#E91912';

export const ORANGE_PRIMARY = '#e96712';

// 順序のあるデータ（グレードなど）を色で表すためのオレンジ単色ランプ。
// 色相を変えず明度だけを4段階にしてあり、濃いほど上位を表す。500 は ORANGE_PRIMARY と同じ。
// 数値は dataviz の検証（明度の単調性・段差・薄い側のコントラスト・単一色相）を通したもの。
export const ORANGE_RAMP_900 = '#7a3608';
export const ORANGE_RAMP_700 = '#b04d0c';
export const ORANGE_RAMP_500 = ORANGE_PRIMARY;
export const ORANGE_RAMP_300 = '#f4a26b';
export const ORANGE_SECONDARY = '#e5a149';
export const ORANGE_SHADOW = '#FFE5D4';

// menu_study_visual_polish: 添削の大ボタン・「いまの目標」空状態バナーの薄オレンジ地／枠
export const ORANGE_PALE = '#fdf3ea';
export const ORANGE_SOFT = '#eed9c4';

export const LINK_BULE = '#2767cf';
export const BORDER = '#b5b4b4';
export const BORDER_SECONDARY = '#f0f0f0';
export const WHITE = '#ffffff';

// menu_study_visual_polish: 「記録する」「教材を探す」のグループカード（薄グレー地）
export const GROUP_CARD_BACKGROUND = '#f7f8f9';
export const GROUP_CARD_BORDER = '#e8eaec';
export const GROUP_CARD_BUTTON_BORDER = '#cfd3d7';

export const RED = 'red';
export const GREEN = '#019F49';
export const CORRECT_PINK = '#E66B58';
export const INCORRECT_BLUE = '#008CAF';
export const BRONZ = '#6a3805';
export const SILVER = '#b4b4b4';
export const GOLD = '#c9b037';
export const SHADOW = '#f8f8f8'
export const SHADOW_PRIMARY = '#eff1f2'
export const SHADOW_YELLOW = '#FFF5DA';
export const SHADOW_BLUE = '#E4EFFF';
export const SHADOW_GREEN = '#DCFCCD';
export const LABEL_GREEN = '#34C759';
export const GREEN_PRIMARY = '#01AB2C';

export const LIGHT_GRAY = '#F1F3F4'

// reply_consultation: 返信の相談ページで AI の発言を見分ける色（確定版モックの色）
export const AI_PURPLE = '#6d4bd1';
export const AI_PURPLE_PALE = '#f3effc';
export const AI_PURPLE_BORDER = '#e3dbf7';
// 返信相談の「管理者に相談」。AI の紫と見分けるための色
export const ADMIN_TEAL = '#0f766e';
export const ADMIN_TEAL_PALE = '#e6f4f2';
export const ADMIN_TEAL_BORDER = '#bfe3dd';
// shindan_reply: 返信画面の「診断テストの返信づくり」の帯（確定版モックの色）
export const LINK_BULE_PALE = '#eef3fc';
export const LINK_BULE_BORDER = '#cddcf6';

export const SCHOOL_GRADE_STRING_VALUES = [
  ['選択してください', null],
  ['小学1年生', 1],
  ['小学2年生', 2],
  ['小学3年生', 3],
  ['小学4年生', 4],
  ['小学5年生', 5],
  ['小学6年生', 6],
  ['中学生以上', 7]
];
export const PREFECTURE_STRING_VALUES: [string, number|null][] = [
  ['選択してください', null],
  ['北海道', 1],
  ['青森県', 2],
  ['岩手県', 3],
  ['宮城県', 4],
  ['秋田県', 5],
  ['山形県', 6],
  ['福島県', 7],
  ['茨城県', 8],
  ['栃木県', 9],
  ['群馬県', 10],
  ['埼玉県', 11],
  ['千葉県', 12],
  ['東京都', 13],
  ['神奈川県', 14],
  ['新潟県', 15],
  ['富山県', 16],
  ['石川県', 17],
  ['福井県', 18],
  ['山梨県', 19],
  ['長野県', 20],
  ['岐阜県', 21],
  ['静岡県', 22],
  ['愛知県', 23],
  ['三重県', 24],
  ['滋賀県', 25],
  ['京都府', 26],
  ['大阪府', 27],
  ['兵庫県', 28],
  ['奈良県', 29],
  ['和歌山県', 30],
  ['鳥取県', 31],
  ['島根県', 32],
  ['岡山県', 33],
  ['広島県', 34],
  ['山口県', 35],
  ['徳島県', 36],
  ['香川県', 37],
  ['愛媛県', 38],
  ['高知県', 39],
  ['福岡県', 40],
  ['佐賀県', 41],
  ['長崎県', 42],
  ['熊本県', 43],
  ['大分県', 44],
  ['宮崎県', 45],
  ['鹿児島県', 46],
  ['沖縄県', 47],
  ['その他', 48]
]

export const renponsiveBreakPoint = 768;

// 変更の場合は、constants.rbの値も変更すること
export const MARUTSUKE_CORPORATE_WEBSITE_URL = 'https://marutsuke.co.jp';


// 目標（マイルストーン）の達成表示。ロードマップ詳細・目標一覧・学習メニューで同じ色を使う
export const MILESTONE_GREEN_ACHIEVED = '#3fa86b';
export const MILESTONE_GRAY_LATER = '#9aa3ab';
export const MILESTONE_LINE_GRAY = '#d8d8d8';
// 進み具合バーの溝。進捗0でも「満タン」に見えないよう、線より薄くする
export const MILESTONE_PROGRESS_TRACK = '#ececec';
// 系統の切り替え（計算力の土台 / プリント学習）の受け皿。白いつまみが乗る
export const MILESTONE_SWITCH_TRACK = '#eeeeef';
